import { Observable } from 'rxjs';
import { ActionConfigDTO } from 'src/components/types';

import { NamingMapping } from 'src/components/visionx/super-admin/tenants/types';

export interface UiPropertiesRequestDTO {
  hostname: string;
  port: string;
  scheme: string;
}

export interface IEnvironment {
  name: string;
  production: boolean;
  apiKey: string;
  authorisation: string;
  VERSION: string;
  apiBase: string;
  useMsalRedirect?: boolean;
  loaded?: boolean;
  googleSSO?: string;
  titlePrefix?: string;
  homePage?: string;
  logoUrl?: string;
  locationOriginUrl?: string; // gets populated with window.location.origin
  loginTitle?: string;
  loginText?: string;
  authType?: AuthType;
  loginLogo?: string;
  loginBackgroundImage?: string;
  loginBackgroundColor?: string;
  loginTextColor?: string;
  loginSmallLogo?: string;
  footer?: string;
  googleAuthenticatorIssuer?: string;
  changePassword?: ActionConfigDTO;
  timeToIdle?: string;
  serverName?: string;
  mttrDisplay?: string;
  appMode?: string;
  applicationMode?: string;
  threatHubDisplay?: string;
  siemType?: string;
  totpSetup?: boolean;
  namingMapping?: NamingMapping;
  getVisibilityEnabled?: boolean;
  wizFeatureEnabled?: boolean;
  splunkMTTXFeatureEnabled?: boolean;
  defenderFeatureEnabled?: boolean;
  sentinelOneFeatureEnabled?: boolean;
  sentinelMttxFeatureEnabled?: boolean;
  noPhishFeatureEnabled?: boolean;
  tenantShortName?: string;
  jiraIncidentsFeatureEnabled?: boolean;
  cisoTrainingFeature?: boolean;
}

export enum AuthType {
  USERNAME_PASSWORD = 'USERNAME_PASSWORD',
  TIME_BASED_ONE_TIME_PASSWORD = 'TIME_BASED_ONE_TIME_PASSWORD',
}

export interface EnvironmentContextProps {
  watchEnvironment: () => Observable<IEnvironment>;
}
